export default __webpack_public_path__ + "static/media/about-years-01.bdd11714.png";